import React from "react";
import './Florestal.css';
import fundofolha from "../image/fundofolha.jpg";
import f1 from "./img/f1.JPG";
import f2 from "./img/f2.JPG";
import f3 from "./img/f3.JPG";
import f4 from "./img/f4.JPG";
import Header from "../components/Header";

const Florestal = () => {
    const handleGoBack = () => {
        window.history.back(); // Volta à página anterior
      };
    return (
     


      <div className="florestal-container">

<Header/>
        <div className="florestal-header">
          <h1>Flora</h1>
          <p>Oferecemos uma ampla gama de serviços para promover a sustentabilidade e saúde de ambientes florestais.</p>
        </div>
        <div className="services-grid">
          <div className="service-card">
            <img
                        src={f3}
                        alt="Laudo Técnico"
                        style={{
                          width: "100%", // Largura total do card
                          height: "auto", // Proporção da imagem
                          objectFit: "cover", // Ajusta a imagem para preencher o espaço
                        }}
                      />
            <h3>Inventários Florestais</h3>
            <p>Avaliamos a composição, estrutura e dinâmica da vegetação, auxiliando em projetos de manejo sustentável e recuperação ambiental.</p>
          </div>
          <div className="service-card">
            <img
                        src={f1}
                        alt="Laudo Técnico"
                        style={{
                          width: "100%", // Largura total do card
                          height: "auto", // Proporção da imagem
                          objectFit: "cover", // Ajusta a imagem para preencher o espaço
                        }}
                      />
            <h3>Diagnóstico de Vegetação</h3>
            <p>
            Oferecemos diagnósticos detalhados da vegetação para embasar ações de conservação e manejo sustentável.
</p>
          </div>
          <div className="service-card">
            <img
                        src={f2}
                        alt="Laudo Técnico"
                        style={{
                          width: "100%", // Largura total do card
                          height: "auto", // Proporção da imagem
                          objectFit: "cover", // Ajusta a imagem para preencher o espaço
                        }}
                      />
            <h3>Elaboração de Planos para Autorizações de Supressão Vegetal (ASV)</h3>
            <p>Elaboramos planos e documentos técnicos para obtenção de ASV, garantindo conformidade legal e compensação ambiental adequada.</p>
          </div>

         


          <div className="service-card">
            <img
                        src={f4}
                        alt="Laudo Técnico"
                        style={{
                          width: "100%", // Largura total do card
                          height: "auto", // Proporção da imagem
                          objectFit: "cover", // Ajusta a imagem para preencher o espaço
                        }}
                      />
            <h3>Caracterização Vegetal</h3>
            <p>Mapeamos a cobertura vegetal com alta precisão, facilitando o planejamento ambiental.</p>
          </div>
          
        </div>
        <div className="back-button-container">
        <button onClick={handleGoBack} className="back-button"   > <i class=" fas fa-solid fa-arrow-left"></i>
          Outros Serviços
        </button>
      </div>
      <section class="footer" style={{
   background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    
    
    color: "#fff" // Para contrastar o texto com o fundo
  }}>
        <div class="box-container">
          <div class="box">
            <h3>Navegue</h3>
            <a href="/">
              {" "}
              <i class="fas fa-chevron-right"></i> Início{" "}
            </a>
            <a href="/#about">
              {" "}
              <i class="fas fa-chevron-right"></i> Sobre{" "}
            </a>
            <a href="/#services">
              {" "}
              <i class="fas fa-chevron-right"></i> Serviços{" "}
            </a>
            <a href="/#doctors">
              {" "}
              <i class="fas fa-chevron-right"></i> Equipe{" "}
            </a>
            <a href="/#book">
              {" "}
              <i class="fas fa-chevron-right"></i> Iniciar conversa{" "}
            </a>
            <a href="/#reviews">
              {" "}
              <i class="fas fa-chevron-right"></i> Avaliações{" "}
            </a>
            <a href="/#blogs">
              {" "}
              <i class="fas fa-chevron-right"></i> Blog{" "}
            </a>
          </div>

          <div class="box">
            <h3>Nossos serviços</h3>
            <a href="/florestal">
              {" "}
              <i class="fas fa-chevron-right"></i> Florestal{" "}
            </a>
            <a href="/fauna">
              {" "}
              <i class="fas fa-chevron-right"></i>  Fauna{" "}
            </a>
            <a href="/propriedade-intelectual">
              {" "}
              <i class="fas fa-chevron-right"></i> Propriedade Intelectual{" "}
            </a>
            <a href="/laudos">
              {" "}
              <i class="fas fa-chevron-right"></i> Laudos e Pareceres Técnicos{" "}
            </a>
            <a href="/levantamentos">
              {" "}
              <i class="fas fa-chevron-right"></i> Levantamentos{" "}
            </a>
          </div>

          <div class="box">
            <h3>Contato </h3>
            <a href="https://wa.me/5534999203789?text=Gostaria%20de%20atendimento%20estava%20navegando%20">
              {" "}
              <i class="fas fa-phone"></i> (34) 9 9920-3789{" "}
            </a>
            <a href="https://wa.me/5511986321639?text=Gostaria%20de%20atendimento%20estava%20navegando%20no%20site!%20">
              {" "}
              <i class="fas fa-phone"></i> (11) 9 8632-1639{" "}
            </a>
            <a href="mailto:emerson@biolinksolucoes.com.br">
              {" "}
              <i class="fas fa-envelope"></i> emerson@biolinksolucoes.com.br{" "}
            </a>
            <a href="mailto:omar.neto@biolinksolucoes.com.br">
              {" "}
              <i class="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br{" "}
            </a>
            <a href="/#book">
              {" "}
              <i class="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais {" "}
            </a>
          </div>

          <div class="box">
            <h3>Conecte-se conosco!</h3>
            <a href="https://www.facebook.com/">
              {" "}
              <i class="fab fa-facebook-f"></i> facebook{" "}
            </a>
          
            <a href="https://www.instagram.com/biolink_ambiental/">
              {" "}
              <i class="fab fa-instagram"></i> instagram{" "}
            </a>
            <a href="https://www.linkedin.com/company/biolink-ambiental/posts/?feedView=all">
              {" "}
              <i class="fab fa-linkedin"></i> linkedin{" "}
            </a>
           
          </div>
        </div>

        <div class="credit">
          {" "}
          Criado por{" "}
          <span>
            <a href="https://instagram.com"> Biolink </a>
          </span>{" "}
          | ©Todos os direitos reservados.{" "}
        </div>
      </section>
      </div>
    );
  };
  
  export default Florestal;